import React, { useState } from 'react';
import { styled, alpha } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import RepPieChart from "./RepPieChart";


// Custom Switch styling
const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: "#49e6b7",
    '&:hover': {
      backgroundColor: alpha("#49e6b7", theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: "#49e6b7",
  },
}));

const RankingTable = ({ topRepData }) => {
  const [includeCEO, setIncludeCEO] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem('token'));
  const role = userDetails ? userDetails.result.role : null;
  const showCeoToggle = !['ABM', 'RBM', 'REPRESENTATIVE'].includes(role);

  const handleToggle = () => {
    setIncludeCEO((prev) => !prev);
  };

  const filteredData = includeCEO
    ? topRepData
    : topRepData.filter((rep) => rep.repname !== 'REP-CEO');
  
  const totalSales = filteredData.reduce((sum, rep) => sum + rep.sales, 0);

  const topFiveData = filteredData.slice(0, 5);

  return (
    <div className="flex flex-col lg:flex-row gap-8 ">
      {/* Pie Chart Section - Full width on mobile, right side on desktop */}
      <div className="w-full lg:w-1/3 order-1 lg:order-2">
        <div className="flex flex-col h-full">
          {showCeoToggle && (
            <div className="flex justify-end mb-4">
              <label className="flex items-center space-x-2">
                <span className="text-sm text-gray-600">Include CEO</span>
                <CustomSwitch
                  checked={includeCEO}
                  onChange={handleToggle}
                  inputProps={{ 'aria-label': 'Include REP-CEO toggle' }}
                />
              </label>
            </div>
          )}
          <div className="flex-1 justify-center items-center">
            <RepPieChart includeCEO={includeCEO} />
          </div>
        </div>
      </div>

      {/* Table Section - Full width on mobile, left side on desktop */}
      <div className="w-full  order-2 lg:order-1 flex justify-center  items-center">
        <div className="overflow-x-auto w-full">
          <table className="min-w-full text-sm text-left text-slate-700">
            <thead className="bg-skin-button text-white">
              <tr>
                <th scope="col" className="px-4 py-3 whitespace-nowrap">
                  #
                </th>
                <th scope="col" className="px-4 py-3 whitespace-nowrap">
                  Representative
                </th>
                <th scope="col" className="px-4 py-3 whitespace-nowrap">
                  Sale Amount
                </th>
                <th scope="col" className="px-4 py-3 whitespace-nowrap">
                  %
                </th>
              </tr>
            </thead>
            <tbody>
              {topFiveData.map((rep, index) => (
                <tr
                  key={rep.repname}
                  className={`border-b transition-colors ${
                    index % 2 === 0 ? 'bg-white' : 'bg-teal-50'
                  } hover:bg-teal-100`}
                >
                  <td className="px-4 py-3 font-medium whitespace-nowrap">
                    {index === 0 ? '👑' : index + 1}
                  </td>
                  <td className="px-4 py-3 font-medium whitespace-nowrap">
                    {rep.repname}
                  </td>
                  <td className="px-4 py-3 font-medium whitespace-nowrap">
                    ₹ {rep.sales.toFixed(0)}
                  </td>
                  <td className="px-4 py-3 font-medium whitespace-nowrap">
                    {((rep.sales / totalSales) * 100).toFixed(2)}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};


export default RankingTable;
